export default __webpack_public_path__ + "static/media/text-input-fail.1300e9dc.svg";